
<!-- 申请单详情 -->
<template>
  <div class="exitSupervision">
    <div class="exitSupervision_top">
      <div class="exitSupervision_top_title">
        <span class="exitSupervision_top_title_left">{{ title }}</span>
        <span class="exitSupervision_top_title_right" :style="(nameType== 0 && !supervisionNoPassData.auditName) ? 'color: #FF8C19' : (nameType == 1 && supervisionNoPassData.auditName) ? 'color: #00B76E' : 'color: #FF4D4D' ">{{ (nameType== 0 && !supervisionNoPassData.auditName) ? '审核中' : (nameType == 1 && supervisionNoPassData.auditName) ? '审核通过' : '审核不通过' }}</span>
      </div>
      <div class="exitSupervision_top_nav line_bottom">
        <div class="exitSupervision_top_time">申请时间：{{ supervisionNoPassData.applyTime | filtTime }}</div>
        <div class="exitSupervision_top_people" v-if="supervisionNoPassData.auditName">审核时间：{{ supervisionNoPassData.auditTime | filtTime }}</div>
      </div>
      <div class="exitSupervision_top_remark" v-if="nameType !== 0">
        <div class="remark">审核意见</div>
        <div class="remark_font">
          <div class="remark_font_size">{{ supervisionNoPassData.auditMemo }}</div>
        </div>
      </div>
      <div class="exitSupervision_top_remark">
        <div class="remark">申请备注</div>
        <div class="remark_font remark_font_two">
          <div class="remark_font_size">{{ supervisionNoPassData.applyMemo }}</div>
        </div>
      </div>

      <div class="exitSupervision_top_remark">
        <div class="remark remark_two">上传附件</div>
        <div class="remark_upload">
          <better-scroll class="file_img" :scrollX="true" v-if="supervisionNoPassData.attach && supervisionNoPassData.attach.length">
            <div class="file_wrapper">
              <img
                  :src="value.url"
                  @click="showViewer(index, $event, supervisionNoPassData.attach.map(e => e.url))"
                  v-for="(value, index) in supervisionNoPassData.attach"
                  :key="index"
                />
            </div>
          </better-scroll>
        </div>
      </div>

      <div class="remark_font_detele" @click="showDetele" v-if="showType">
            <span>查看重点关注详情</span>
            <img src="../../../../assets/integrity/ic_xl@3x.png" alt="">
          </div>

    </div>
    <div class="exitSupervision_bottom">
      <div class="result line_bottom">
        <div class="title">
          <div>审核流程</div>
        </div>
      </div>
      <div class="toBeRectified">
        <div class="toBeRectified_dop">
          <div class="toBeRectified_dop_top" v-if="supervisionNoPassData.auditName"></div>
          <div class="toBeRectified_dop_top" v-else :style="'border: 1px solid #999999'"></div>
          <div class="toBeRectified_dop_line"></div>
          <div class="toBeRectified_dop_top"></div>
        </div>
        <div class="toBeRectified_title">
          <div>
            <div class="toBeRectified_title_top">
              <div class="toBeRectified_title_top_people">上级审核人：{{ supervisionNoPassData.auditName }}</div>
              <div class="toBeRectified_title_top_examine" v-if="supervisionNoPassData.auditName">已审核</div>
              <div class="toBeRectified_title_top_examine" :style="'color: #999999; font-weight:400;'" v-else>待审核</div>
            </div>
            <div class="toBeRectified_title_top_examine_time">审核时间：{{ supervisionNoPassData.auditTime | filtTime }}</div>
          </div>
          <div>
            <div class="toBeRectified_title_top toBeRectified_title_bottom">
              <div class="toBeRectified_title_top_people">申请人：{{ supervisionNoPassData.applyName }}</div>
              <div class="toBeRectified_title_top_examine">已提交</div>
            </div>
            <div class="toBeRectified_title_top_examine_time">申请时间：{{ supervisionNoPassData.applyTime | filtTime }} </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import api from '../../../../service/modules/integrity';
    import betterScroll from '../../components/betterScroll';

    export default {
        components: {
            betterScroll
        },
        data () {
            return {
                showType: this.$route.query.showType,
                title: this.$route.query.title,
                isShowToast: false,
                nameType: this.$route.query.type,
                supervisionNoPassData: {}
            }
        },
        created () {
          console.log(this.nameType, '--------')
            this.getSupervisionNoPass();
        },
        methods: {
            getSupervisionNoPass () {
                api.supervisionExit({ taskId: this.$route.query.taskId }).then(res => {
                    if (res.ret === 0) {
                        this.supervisionNoPassData = res.data;
                    }
                })
            },
            showDetele () {
                this.$router.replace({
                    path: 'supervisionDetails',
                    query: {
                        enterpriseId: this.supervisionNoPassData.enterpriseDetail.enterpriseId,
                        supervisionId: this.supervisionNoPassData.supervisionId
                    }
                })
            },
            // 图片预览
            showViewer (index, event, imgList) {
                this.$router.push({
                  path: '/complaint/imagesView',
                  query: {
                    imageList:imgList|| [],
                    index
                  },
                })
                // this.$ImagePreview({
                //     images: imgList,
                //     startPosition: index,
                //     closeOnPopstate: true
                // });
            },
            /** 审核 */
            changeBtn () {
                this.$router.push({
                    path: '/index',
                    query: {
                        isShowToast: true
                    }
                })
                this.isShowToast = true;
                setTimeout(() => {
                    this.isShowToast = false;
                }, 2000)
                // this.$Toast({
                //     message: '处理成功',
                //     icon: 'passed'
                // });
            },
            /** 诚信指数详情 */
            goGradeDetail () {

            },
            cancelScenic () {
                this.isShowExaminePicker = false;
            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                if (str) {
                  var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                  var Y = date.getFullYear() + "-";
                  var M =
                      (date.getMonth() + 1 < 10
                      ? "0" + (date.getMonth() + 1)
                      : date.getMonth() + 1) + "-";
                  var D =
                      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
                  var h =
                      (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
                  var m =
                      (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
                      ":";
                  var s =
                      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                  let strDate = Y + M + D + h + m + s;
                  return strDate;
                } else {
                  return str;
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.exitSupervision {
  color: #333;
  width: 100%;
  min-height: 100%;
  background-color: #fbfbfb;
  padding: 21px 12px 84px 12px;
  box-sizing: border-box;
  .exitSupervision_top {
    width: 100%;
    height: 100%;
    background-color: #fff;
    float: left;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-bottom: 16px;
    .exitSupervision_top_title {
      display: flex;
      justify-content: space-between;
      font-size:16px;
      font-weight:600;
      color: #333;
      padding: 16px;
      .exitSupervision_top_title_left {
        display: inline-block;
        width: 240px;
        line-height: 1.3em;
      }
      .exitSupervision_top_title_right {
        margin-top: 2px;
        font-size:14px;
        font-weight:400;
        color: #FF8C19;
      }
    }
    .exitSupervision_top_nav {
      padding: 0 16px 16px 16px;
      color: #666;
      font-size:14px;
      font-weight:400;
      .exitSupervision_top_people{
        margin-top: 12px;
        }
      .exitSupervision_top_time {

      }
    }
    .remark_font_detele {
      margin: 16px;
      color: #36B374;
      font-size:12px;
      font-weight:400;
      display: flex;
      justify-content: left;
      align-items: center;
      span{
        display: inline-block;
      }
      img{
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-left: 4px;
      }
    }
    .exitSupervision_top_remark {

      .remark {
        padding: 16px 16px 12px 16px;
        font-size:14px;
        font-weight:500;
        color: #333333;
      }
      .remark_two{
        font-size:14px;
        font-weight:400;
        color: #666666;
      }
      .remark_font_two {
        margin-bottom: 16px;
      }
      .remark_font {
        margin: 0 16px ;
        background: #F8F8F8;
        color: #333333;
        font-weight:400;
        padding: 8px 16px;
        .remark_font_size {
          font-size:14px;
          line-height: 24px;
        }
        .remark_font_detele_time {
          color: #999999;
          font-size:12px;
          font-weight:400;
          .remark_applicant {
            margin: 8px 0;
          }
          .remark_time {
            margin-bottom: 6px;
          }
        }
      }
      .remark_upload {
        margin: 0 16px 16px;
        .file_img{
          width:100%;
          height:74px;
          position: relative;
          overflow: hidden;
          .file_wrapper{
            height:74px;
            white-space: nowrap;
            position:absolute;
            img{
                width: 74px;
                height: 74px;
                display: inline-block;
                margin-left: 8px;
                border-radius: 3px;
            }
            img:nth-child(1){
              margin-left:0;
            }
          }
        }
      }
    }
  }
  .exitSupervision_bottom {
    width: 100%;
    background-color: #fff;
    float: left;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-bottom: 24px;
    .result {
      width: 100%;
      padding: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 14px;
        color: #333;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
      }
    }
    .toBeRectified {
      // width: 100%;
      // height: 100%;
      display: flex;
      justify-content: left;
      margin: 16px;
      .toBeRectified_dop {
        margin-right: 12px;
        .toBeRectified_dop_top {
          border: 1px solid #36B374;
          border-radius: 50%;
          width: 14px;
          height: 14px;
        }
        .toBeRectified_dop_line {
          height: 58px;
          border-left: 1px solid #EAEAEA;
          margin-left: 7px;
        }
      }
      .toBeRectified_title {
        width: 100%;
        .toBeRectified_title_top {
          display: flex;
          justify-content: space-between;
          .toBeRectified_title_top_people {
            font-size:14px;
            font-weight:600;
            color: #333333;
          }
          .toBeRectified_title_top_examine {
            font-size:12px;
            font-weight:400;
            color: #39B476;
          }
        }
        .toBeRectified_title_bottom{
          margin-top: 36px;
        }
        .toBeRectified_title_top_examine_time {
          margin-top: 12px;
          font-size:12px;
          font-weight:400;
          color: #999999;
        }
      }
    }
  }
}
</style>
